// extracted by mini-css-extract-plugin
export default {"select":"CabinetTypicalDocuments_select__h2mht"};